import { useEffect, useState } from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import { DEV_URL, rget } from "../../utils/requests";
import loader from "../../assets/images/datahub-loader.svg";
import Table from "components/UnifiedMarkupTable";

interface StatusDetailModalProps {
  show: boolean;
  huRequestId: number | null;
  onClose: () => void;
}

interface StatusCountItem {
  status: string;
  count: number;
}

interface IHUTranStatusCount {
  huTranId: number;
  totalCount: number;
  statusCounts: StatusCountItem[];
}

const StatusDetailModal = ({
  show,
  huRequestId,
  onClose,
}: StatusDetailModalProps) => {
  const [data, setData] = useState<IHUTranStatusCount | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!show || !huRequestId) return;

    const fetchStatusDetail = async () => {
      try {
        setLoading(true);
        const response = await rget(
          `${DEV_URL}/api/HistoricalUsage/hu-requests-status/${huRequestId}`
        );
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching status details:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStatusDetail();
  }, [show, huRequestId]);

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "pending": return "text-warning";
      case "partial": return "text-danger";
      case "completed": return "text-success";
      default: return "";
    }
  };

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      show={show}
      onHide={onClose}
      centered
      size="sm"
      title="Status Count"
      confirmButtonLabel="Close"
      onConfirm={onClose}
    >
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "150px" }}
          >
            <img src={loader} height={44} alt="Loading" />
          </div>
        ) : data ? (
          <Table bordered size="sm" className="mb-0">
            <tbody>
              <tr>
                <td className="fw-semibold">Total</td>
                <td className="text-end">{data.totalCount}</td>
              </tr>
              {data.statusCounts.map((item, i) => (
                <tr key={i}>
                  <td className={`fw-semibold ${getStatusColor(item.status)}`}>
                    {item.status}
                  </td>
                  <td className="text-end">{item.count}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted text-center my-4">No data available</p>
        )}
    </ConfirmationModal>
  );
};

export default StatusDetailModal;
